import styled, {css} from 'styled-components/macro';
import Icon from './Icon';

import pinShadow from "../images/pin-shadow.png";

const PinWrapper = styled.div.attrs(props => ({
    style: {
        transform: `scale(${props.scaleFix})`,
    },
    }))`
    position:absolute;
    transform-origin: bottom;
    left: calc(${props => props.posX}% - 23px);
    top: calc(${props => props.posY}% - 66px);
    z-index: ${props => props.activePinNumber ? '-1' : '2'};

    &:hover {
        cursor:pointer;
    }

    opacity:0;
    transform:scale(0);
    animation-name: ${props => props.isDesktop ? 'pinDrop' : 'pinDropMobile'};
    animation-duration: 1s;
    animation-timing-function: cubic-bezier(0.03, 1.3, 1, 1);
    animation-fill-mode: forwards;
    animation-delay: ${props => props.animDelay ? props.animDelay + 's' : '0s'};
    
`

const PinContainer = styled.div`
    position:relative;
    transition: transform .2s cubic-bezier(0.03, 1.3, 1, 1);
    // transition: opacity 1s ease-in 2s;

    // opacity:1;
    ${ props => props.activePinNumber && css`
        opacity:0;
    `}

    ${PinWrapper}:hover & {
        transform:scale(1.15);
    }

`

const PinMarker = styled.div`
    svg {
        /* box-shadow: , 0px 21.3066px 33.4221px rgba(0, 0, 0, 0.10064), 0px 11.3915px 17.869px rgba(0, 0, 0, 0.083455), 0px 6.38599px 10.0172px rgba(0, 0, 0, 0.07), 0px 3.39155px 5.32008px rgba(0, 0, 0, 0.056545), 0px 1.4113px 2.21381px rgba(0, 0, 0, 0.0393604); */
        //filter: drop-shadow(0px 5px 8px rgb(0 0 0 / 0.4));
    }
    path {
        transition: fill .5s cubic-bezier(0.03, 1.3, 1, 1);
    }
    ${PinWrapper}:hover & {
        svg path {
             fill: #CAD2DD;
            // fill: #0C3E8D;
        }
    } 
`

const PinNumber = styled.div`
    position:absolute;
    font-size:24px;
    font-weight:700;
    color:#fff;
    top:38%;
    left:49%;
    transform: translateX(-50%) translateY(-50%);
`

const PinShadow = styled.img`
    && {
        width:380%;
    }
    position:absolute;
    z-index:-1;
    transform: translateX(-50%) translateY(-27%);
    top:50%;
    left:50%;
    pointer-events:none;
    touch-events:none;
`

export default function Pin(props){

    // counter (x) the parent scale (y) so as to return to 1 
    // yx = 1, or x = 1/y 
    let scaleFix = 1 / props.scaleBase;

    let id = 'a' + props.id;

    return(
        <PinWrapper 
            posY={props.posY} 
            posX={props.posX} 
            onClick={()=>props.setActivePinNumber(props.number)}
            scaleFix={scaleFix}
            animDelay={props.animDelay}
            isDesktop={props.isDesktop}
            activePinNumber={props.activePinNumber}
            >
            <PinShadow src={pinShadow} alt='' aria-hidden="true" />
            <PinContainer activePinNumber={props.activePinNumber}>
                <PinMarker>
                    <svg width="46" height="64" viewBox="0 0 46 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path fillRule="evenodd" clipRule="evenodd" d="M45.8993 13.25L22.9497 0L0 13.25V39.75L21.4497 52.134V64H24.4497V52.134L45.8993 39.75V13.25Z" fill="#F79A37"/>
                    </svg>
                </PinMarker>
                <PinNumber> {props.number} </PinNumber>
            </PinContainer>
        </PinWrapper>
    )
}